import React, { Fragment } from 'react';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import type { IconSortMapping } from '../types/general';
import type { ValueIndicator as ValueIndicatorType } from '../types/form';

type Props<T> = {
  field: ValueIndicatorType;
  item: T;
  iconSortMapping: IconSortMapping;
};

function ValueIndicator<T>({ field, item, iconSortMapping }: Props<T>) {
  const value = item[field.itemFieldKey as keyof T] || '';
  const mapping = typeof value === 'string' ? iconSortMapping[value] : undefined;

  return (
    <Fragment key={field.key}>
      <Grid item xs={field.xsWidth != null ? field.xsWidth : 12}>
        <Box display='flex' flexDirection='row' alignItems='center' mt={2.5}>
          {mapping !== undefined ? mapping.icon : ' - '}
          <Typography fontSize='1rem' mb={0} ml={1}>
            {field.label}
          </Typography>
        </Box>
      </Grid>
    </Fragment>
  );
}

export default ValueIndicator;
